import { render, staticRenderFns } from "./OnboardingIlustra.vue?vue&type=template&id=68dc1e3f&scoped=true&"
import script from "./OnboardingIlustra.vue?vue&type=script&lang=ts&"
export * from "./OnboardingIlustra.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingIlustra.vue?vue&type=style&index=0&id=68dc1e3f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc1e3f",
  null
  
)

export default component.exports